// externalConnectionsApi.ts

import { ExternalConnectionData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';
import apiFetch from '../../../common/services/apiFetch';

const baseApi = apiResource<ExternalConnectionData>('external-connections');

export const externalConnectionsApi = {
	...baseApi, // CRUD générique

	// méthode spécifique : test de connexion
	testConnection: (id: number, token: string) =>
		apiFetch(`${getApiBaseUrl()}/v2/external-connections/${id}/test`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}).then(async (res) => {
			if (!res.ok) {
				const text = await res.text();
				throw new Error(`Test failed: ${text}`);
			}
			return res.json();
		}),

	// autre méthode spécifique : preview mouvements
	previewMovements: (id: number, token: string) =>
		apiFetch(`${getApiBaseUrl()}/v2/external-connections/${id}/preview`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}).then(async (res) => {
			if (!res.ok) {
				const text = await res.text();
				throw new Error(`Preview failed: ${text}`);
			}
			return res.json();
		}),

	// autre méthode spécifique : importer les mouvements
	importMovements: (
		id: number,
		token: string,
		params: { fromOriginalDateTime?: string; limit?: number; dryRun?: boolean }
	) =>
		apiFetch(`${getApiBaseUrl()}/v2/external-connections/${id}/import`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(params),
		}).then(async (res) => {
			if (!res.ok) {
				const text = await res.text();
				throw new Error(`Import failed: ${text}`);
			}
			return res.json();
		}),
};
